import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classnames from 'classnames'

import { forgot } from '_modules/user/actions'

import styles from './styles.css'

const mapDispatchToProps = {
  forgot,
}

class ForgotPassword extends PureComponent {
  static propTypes = {
    forgot: PropTypes.func.isRequired,
  }

  static defaultProps = {}

  state = {
    email: '',
    sent: '',
  }

  onChangeTrim = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value.trim(),
    })
  }

  onSubmit = event => {
    event.preventDefault()
    const { email } = this.state

    const payload = {
      email,
    }

    const valid = this.validateEmail(email)

    if (valid) this.props.forgot(payload)

    this.setState({
      sent: valid ? `An email has been sent to ${email} with further instructions.` : '',
    })
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onSubmit(event)
    }
  }

  validateEmail = email => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  render() {
    const { email, sent } = this.state
    return (
      <div>
        <form onSubmit={this.onSubmit} className={classnames(styles.main, styles.Grid)}>
          <div
            className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles['page-name'])}
          >
            Forgotten Password Request
          </div>
          <div style={{ margin: 20 }} />
          <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
            <input
              type="text"
              id="email"
              placeholder="Email"
              value={email}
              onChange={this.onChangeTrim}
              className={styles.input}
              onKeyPress={this.onKeyPress}
            />
          </div>
          <div style={{ margin: 20 }} />
          {sent && (
            <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.msg)}>
              {sent}
            </div>
          )}
          <div style={{ margin: 5 }} />
          <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
            <button type="submit" onClick={this.onSubmit} className={classnames(styles.button)}>
              {sent ? 'SEND AGAIN' : 'SUBMIT'}
            </button>
          </div>
        </form>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/views/forgot-password/index.js